'use client'

import CTA from '@/components/CTA'
import ContentBlocks from '@/components/ContentBlocks'
import PageHeader from '@/components/PageHeader'
import ProjectCover from '@/components/ProjectCover'
import Credits from '@/components/Credits'
import ProjectIntro from '@/components/ProjectIntro'
import RelatedProjectsGrid from '@/components/RelatedProjectsGrid'
import { FC } from 'react'

interface ProjectLayoutProps {
	data: any
}

const ProjectLayout: FC<ProjectLayoutProps> = ({ data }) => {

	return (
		<>
			<div className="site-wrapper project-layout">

				<PageHeader title={data?.title} align="center" />

				<ProjectCover media={data?.coverMedia} />

				<ProjectIntro headline={data?.headline} sectors={data?.sectors} deliverables={data?.deliverables} />

				<ContentBlocks contentBlocks={data?.contentBlocks} />

				<Credits credits={data?.credits} />

			</div>

			{data?.relatedProjects?.length > 0 && <RelatedProjectsGrid relatedProjects={data?.relatedProjects} />}

			<CTA href="/work" heading={'All case studies'} />
		</>
	)
}
export default ProjectLayout
